// @ts-nocheck
import _ from 'lodash';
import PropTypes from 'prop-types';
import { makeStyles, Box, Button, Icon, TextField, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';

const useStyles = makeStyles(theme => ({
  form: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  fieldWrapper: {
    flex: '1',
    maxWidth: '500px',
  },
  caption: {
    marginTop: theme.spacing(1),
  },
  searchButton: {
    maxHeight: '40px',
    marginLeft: theme.spacing(1),
  },
}));

function VoucherSearch(props) {
  const [t] = useTranslation();
  const { formState, errors, register, handleSubmit } = useForm();
  const classes = useStyles();

  const { onFetchVoucher } = props;
  const { isSubmitting, isDirty } = formState;

  const onSubmit = async data => {
    const voucherNo = _.get(data, 'voucherno');
    await onFetchVoucher(voucherNo);
  };

  return (
    <Box id="VoucherSearch-container">
      <form id="VoucherSearch-form" onSubmit={handleSubmit(onSubmit)} className={classes.form}>
        <Box className={classes.fieldWrapper}>
          <TextField
            id="VoucherSearch-voucherNo"
            name="voucherno"
            label={t('voucher.voucherNo')}
            variant="outlined"
            size="small"
            error={!!errors.voucherno}
            helperText={errors.voucherno?.message}
            inputRef={register({
              minLength: {
                value: 8,
                message: t('voucher.voucherMinLength'),
              },
            })}
            fullWidth
          />
          <Typography variant="caption" component="div" className={classes.caption}>
            {t('voucher.voucherNoCaption')}
          </Typography>
        </Box>
        <Button
          id="VoucherSearch-submit"
          type="submit"
          size="large"
          color="primary"
          variant="outlined"
          className={classes.searchButton}
          startIcon={<Icon>search</Icon>}
          disabled={isSubmitting || !isDirty || !_.isEmpty(errors)}
        >
          {t('common.search')}
        </Button>
      </form>
    </Box>
  );
}

VoucherSearch.propTypes = {
  onFetchVoucher: PropTypes.func.isRequired,
};

export default VoucherSearch;
